export default function CarouselSection() {
  const features = [
    {
      id: 1,
      title: '揭秘：娱乐圈资本博弈背后的秘密棋局',
      tag: '深度专题',
      summary: '从对赌协议到股权置换，深度剖析娱乐公司背后的资本运作逻辑与艺人命运的关系。',
      image: 'https://readdy.ai/api/search-image?query=dramatic%20wide%20cinematic%20shot%20of%20entertainment%20awards%20ceremony%20backstage%20with%20mysterious%20atmosphere%2C%20deep%20shadows%20with%20warm%20golden%20ambient%20light%2C%20exclusive%20behind%20the%20scenes%20mood%2C%20rich%20dark%20tones%2C%20luxurious%20setting&width=1600&height=800&seq=carousel-01&orientation=landscape',
    },
    {
      id: 2,
      title: '2024娱乐圈年度十大翻车事件全盘点',
      tag: '年度盘点',
      summary: '从人设崩塌到法律红线，回顾今年那些让吃瓜群众目瞪口呆的惊天大瓜。',
      image: 'https://readdy.ai/api/search-image?query=atmospheric%20wide%20shot%20of%20late%20night%20city%20skyline%20with%20neon%20signs%20and%20breaking%20news%20headlines%20projected%20on%20buildings%2C%20cyberpunk%20meets%20journalism%20aesthetic%2C%20warm%20amber%20and%20crimson%20tones%2C%20dramatic%20lighting&width=1600&height=800&seq=carousel-02&orientation=landscape',
    },
    {
      id: 3,
      title: '选秀节目十年变迁：从全民狂欢到黯然落幕',
      tag: '行业观察',
      summary: '曾经风靡全国的选秀综艺为何走向衰落？背后的政策、资本与观众心态变化全解析。',
      image: 'https://readdy.ai/api/search-image?query=cinematic%20wide%20composition%20of%20vintage%20newspaper%20printing%20press%20in%20dramatic%20lighting%2C%20warm%20sepia%20and%20amber%20tones%2C%20industrial%20journalism%20atmosphere%2C%20deep%20shadows%2C%20documentary%20photography%20style&width=1600&height=800&seq=carousel-03&orientation=landscape',
    },
    {
      id: 4,
      title: '网红经济泡沫破裂：谁在裸泳？',
      tag: '趋势分析',
      summary: '当流量红利消退，那些靠炒作和造假堆起来的网红帝国正在一个接一个地崩塌。',
      image: 'https://readdy.ai/api/search-image?query=dramatic%20wide%20shot%20of%20anonymous%20figure%20walking%20through%20corridor%20of%20digital%20screens%20showing%20social%20media%20trends%2C%20modern%20surveillance%20aesthetic%2C%20warm%20highlights%20against%20dark%20background%2C%20cinematic%20composition&width=1600&height=800&seq=carousel-04&orientation=landscape',
    },
    {
      id: 5,
      title: '明星代言的隐秘江湖：谁在替你的钱包负责？',
      tag: '消费警示',
      summary: '从夸大宣传到虚假代言，揭开明星商业代言背后的灰色地带与消费者维权困境。',
      image: 'https://readdy.ai/api/search-image?query=atmospheric%20wide%20shot%20of%20exclusive%20VIP%20club%20interior%20with%20mysterious%20figures%20in%20shadow%2C%20golden%20warm%20lighting%2C%20luxury%20entertainment%20industry%20setting%2C%20rich%20amber%20and%20dark%20tones%2C%20cinematic%20composition&width=1600&height=800&seq=carousel-05&orientation=landscape',
    },
  ];

  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-flex items-center gap-1.5 text-xs font-medium text-primary-400 bg-primary-100/15 px-3 py-1 rounded-full mb-4 whitespace-nowrap">
            <i className="ri-sparkling-line"></i>
            Featured
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-50 mb-3">
            焦点专题
          </h2>
          <p className="text-sm text-foreground-500">深度解读黑料背后的故事与趋势</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-4">
          {features.map((feat) => (
            <article
              key={feat.id}
              className="bg-background-100 border border-background-200/60 rounded-lg overflow-hidden hover:border-background-300/60 transition-all group cursor-pointer"
            >
              <div className="relative w-full h-40 overflow-hidden">
                <img
                  src={feat.image}
                  alt={feat.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-background-50/80 via-transparent to-transparent"></div>
                <div className="absolute bottom-2 left-2">
                  <span className="inline-block px-2 py-0.5 rounded text-[10px] font-semibold bg-primary-500/90 text-background-950 whitespace-nowrap">
                    {feat.tag}
                  </span>
                </div>
              </div>
              <div className="p-3">
                <h3 className="font-heading text-sm font-bold text-foreground-100 mb-1.5 leading-snug group-hover:text-primary-400 transition-colors line-clamp-2">
                  {feat.title}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2">{feat.summary}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}